// src/hooks/useSocketEvent.ts
// React hook to subscribe to socket events from socketService.
// Equivalent to $rootScope.$on("socket:client:*", handler) in legacy AngularJS.
//
// Usage:
//   useSocketEvent('socket:client:notification', (data) => {
//     console.log('New notification:', data);
//   });

import { useEffect } from 'react';
import { socketService, type SocketEventName } from '../services/socketService';

/**
 * Subscribe to a socket event for the lifetime of the component.
 * Automatically unsubscribes on unmount.
 */
export function useSocketEvent<T = any>(event: SocketEventName, handler: (data: T) => void): void
{
  useEffect(() =>
  {
    return socketService.on(event, handler);
    // handler identity may change — wrap stable refs in useCallback at call site if needed
  }, [event, handler]);
}
